import BrokerSettlement from './BrokerSettlement';
import {authRoles} from 'auth/auth';
import LoadUserData from '../../LoadUserData';

export const BrokerConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth    : authRoles.admin,//['admin','staff']
    routes  : [
        {
            path     : '/brokersettlement',
            component: LoadUserData(BrokerSettlement)
        }
    ]
};



// WEBPACK FOOTER //
// ./src/main/content/brokersettlement/BrokerSettlementConfig.js